<template>
    <div v-if="have_data == true">
        <section class="section section-shaped section-md my-0 section-header-pages single-region">
            <div class="shape shape-style-1 bg-gradient-default">
                <span></span>
                <span></span>
                <span style="visibility:hidden"></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container shape-container d-flex">
                <div class="col px-0">
                    <div class="row">
                        <div class="col-lg-12 col-md-12">
                            <div class="d-flex  align-items-end data-head-single" style="height: 100%;">
                                <div class="flex-column">
                                    <h2 class="display-2 mb-0 text-white">{{ city_name }}</h2>
                                    <h5 class="mb-0 text-white"><span class="text-header-title">Gestión:</span> {{ year }}</h5>
                                    <h5 class="mb-0 mt-3 text-white font-weight-100">Ranking Municipal de IIEG</h5>
                                    <!--<div class="btn-wrapper mt-4">
                                      <vue-bootstrap-typeahead
                                          v-model="query"
                                          placeholder="Buscar municipio..."
                                          :data="municipalities"
                                          class="custom-input mt-3"
                                      />
                                    </div>-->
                                </div>
                            </div>
                        </div>

                        <div class="col-12">
                          <div class="custom-bredcrumbs site-nav-wrap">
                             <nav class="nav">
                                <div class="single-breadcrumb-wrap">
                                  <span class="sep"><i class="fa fa-caret-right"></i></span> <span class="breadcrumb2">
                                    <router-link :to="{ name: 'investment.home' }">Inicio IIEG</router-link>
                                  </span>
                                </div>
                                <div class="single-breadcrumb-wrap">
                                  <span class="sep"><i class="fa fa-caret-right"></i></span> <span class="breadcrumb2">
                                    <router-link :to="{ name: 'investment.municipalities.national', params: { year: year, city: 0 } }">Bolivia</router-link>
                                  </span>
                                </div>
                               <div class="single-breadcrumb-wrap">
                                  <span class="sep"><i class="fa fa-caret-right"></i></span> <span class="breadcrumb2">
                                    <a href="javascript:;">Ranking Municipal</a>
                                  </span>
                                </div>
                            </nav>
                          </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
        <section class="section section-md pb-5 mb-5">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-lg-12">

                        <h4>A. Ranking de Inversión, Igualdad y Equidad de Género IIEG</h4>
                        <p>Presupuesto de inversión total y presupuesto de IIEG</p>

                        <card shadow body-classes="px-2 py-4" class="mt-5">
                          <div class="table-responsive box-table-custom">
                              <div class="container">
                                  <v-client-table
                                      :data="tableData"
                                      :columns="columns"
                                      :options="options">

                                      <a slot="name" slot-scope="props" v-on:click="redirectToRegion(props.row)" class="link-to">{{ props.row.name }}</a>

                                      <span slot="total_programmed_budget" slot-scope="props">{{ props.row.total_programmed_budget | decimal }}</span>
                                      <span slot="total_executed_budget" slot-scope="props">{{ props.row.total_executed_budget | decimal }}</span>
                                      <span slot="iieg_programmed_budget" slot-scope="props">{{ props.row.iieg_programmed_budget | decimal }}</span>
                                      <span slot="iieg_executed_budget" slot-scope="props">{{ props.row.iieg_executed_budget | decimal }}</span>


                                      <div slot="iieg_percent" slot-scope="props">{{ props.row.iieg_percent }}%</div>
                                      <div slot="total_percent" slot-scope="props" :class="slugify(props.row.qualification) + ' box-row'">{{ props.row.total_percent }}%</div>

                                  </v-client-table>
                              </div>
                          </div>
                        </card>

                        <div class="mb-0 mt-5">
                          <p class="text-muted"></p>
                          <p class="text-muted" style="font-size: 0.9rem !important; text-align: center">
                            (a) Presupuesto de Inversión Municipal Programado  Total Menos Deudas.<br>
                            (b) Presupuesto de Inversión Municipal Ejecutado Total Menos Deudas. <br>
                            (c) % de ejecución respeto al total del presupuesto municipal ejecutado.<br>
                          </p>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    </div>
    <div v-else>
       <section class="section section-shaped section-md my-0 section-header-pages single-region">
            <div class="shape shape-style-1 bg-gradient-default">
                <span></span>
                <span></span>
                <span style="visibility:hidden"></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container shape-container d-flex">
                <div class="col px-0">
                    <div class="row">
                        <div class="col-lg-12 col-md-12">
                            <div class="d-flex  align-items-end data-head-single" style="height: 100%;">
                                <div class="flex-column">
                                    <h2 class="display-2 mb-0 text-white">{{ city_name }}</h2>
                                    <h5 class="mb-0 text-white">Gestión: {{ year }}</h5>
                                    <h5 class="mb-0 mt-3 text-white font-weight-100">Ranking Municipal de IIEG</h5>
                                    <div class="btn-wrapper mt-4">
                                      <vue-bootstrap-typeahead
                                          v-model="query"
                                          placeholder="Buscar municipio..."
                                          :data="municipalities"
                                          class="custom-input mt-3"
                                      />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
        <section class="section section-md">
            <div class="container">
                <div class="row row-grid align-items-center--">
                    <div class="col-lg-12">
                        <div class="">
                            <h3><span class="fa fa-flash"></span> No existen datos para mostrar.</h3>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
const axios = require('axios');

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
am4core.useTheme(am4themes_animated);

import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
import {ClientTable} from 'vue-tables-2';

import Vue from 'vue';
Vue.use(ClientTable);

export default {
  name: "list",
  data() {
    return {
        have_data: true,
        city_name: '',
        year: '',
        chart: '',
        detail: '',

        query: '',
        municipalities: [],

        columns: ['id', 'name', 'total_programmed_budget', 'total_executed_budget', 'iieg_programmed_budget', 'iieg_executed_budget', 'iieg_percent', 'total_percent', 'category_population'],
        tableData: [],

        options: {

            headings: {
                id: 'Nº',
                name: 'Municipio',
                total_programmed_budget: 'Programado (a)',
                total_executed_budget: 'Ejecutado (b)',
                iieg_programmed_budget: 'Programado IIEG',
                iieg_executed_budget: 'Ejecutado IIEG',
                iieg_percent: '% IIEG ejecutado',
                total_percent: '% Total (c)',
                category_population: 'Cat.'
            },
            columnsClasses: {
              total_programmed_budget: 'text-right',
              total_executed_budget: 'text-right',
              iieg_programmed_budget: 'text-right',
              iieg_executed_budget: 'text-right',
              iieg_percent: 'text-right',
              total_percent: 'text-right',
              category_population: 'text-center'
            },
            sortable: ['name',],
            filterable: ['name',],
            templates: {
              id: function(h, row, index){
                return index;
              }
            },
            texts: {
              count: "Mostrando {from} a {to} de {count} registros|{count} registros|Un registro",
              first: 'Primero',
              last: 'Último',
              filter: "Buscar:",
              filterPlaceholder: "Palabra a buscar",
              limit: "Mostar:",
              page: "Página:",
              noResults: "No se encontraron coincidencias",
              filterBy: "Filter by {column}",
              loading: 'Cargando...',
              defaultOption: 'Select {column}',
              columns: 'Columnas'
            },
        }
    }
  },
  components: {
    VueBootstrapTypeahead,

    //ServerTable,
    ClientTable,
    //Event,
  },
  filters: {
    decimal(num) {
        var nStr = parseFloat(num).toFixed(0); //2
        nStr += '';
        var x = nStr.split('.');
        var x1 = x[0];
        var x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;

        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    }
  },
  computed: {
    dec(num){
      return  num;
    },
    executedTotalPercent(){
        let percent = (this.detail.total_executed_budget * 100)/this.detail.total_programmed_budget;
        return parseInt(percent);
    },
    executedIIEGPercent(){
        let percent = (this.detail.iieg_executed_budget * 100)/this.detail.iieg_programmed_budget;
        return parseInt(percent);
    }
  },
  methods: {

    getDataRows(){
      //this.isLoading.table3 = true;
      let uri = process.env.VUE_APP_API_DOMAIN + `/apiv1` + `/investments/y/${this.$route.params.year}/t/municipalities/c/${this.$route.params.city}/listTable`;
      axios.get(uri).then((response) => {
        console.log(response.data);
          if(response.data.success) {
              this.tableData = response.data.rows;
              this.city_name = response.data.city.city;
              this.year = response.data.year;
          } else {
            if(response.data.having_data == false) {
              this.year = response.data.year;
              this.have_data = false;
            }
          }
      }).catch((response) => {
          console.log(response)
      }).finally(() => {
          //this.isLoading.table3 = false;
      });

    },

    redirectToRegion($e) {
        this.$router.push({name:'investment.region.single', params: {year:this.$route.params.year, type: 'municipios', code: $e.code, name: this.slugify($e.name) }})
    },

    slugify(text) {
      return text.toString().toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    }

  },
  mounted() {
    this.getDataRows();
  }

};
</script>

<style scoped>
.VuePagination {
  text-align: center;
  margin-top: 20px !important;
  padding-top: 30px !important;
}

.vue-title {
  text-align: center;
  margin-bottom: 10px;
}

.vue-pagination-ad {
  text-align: center;
}

.glyphicon.glyphicon-eye-open {
  width: 16px;
  display: block;
  margin: 0 auto;
}

th:nth-child(3) {
  text-align: center;
}

.VueTables__child-row-toggler {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: block;
  margin: auto;
  text-align: center;
}

.VueTables__child-row-toggler--closed::before {
  content: "+";
}

.VueTables__child-row-toggler--open::before {
  content: "-";
}
/*styles badges*/
.box-row {
  padding: 5px;
  border-radius: 5px;
  background-color: #eee;
}

.buena {
  background-color: darkseagreen;
  color: #fff;
}
.muy-buena {
  background-color: cornflowerblue;
  color: #fff;
}
.aceptable {
  background-color: #e4e400;
  color: #fff;
}
.delicada {
  background-color: darkorange;
  color: #fff;
}
.crtica {
  background-color: red;
  color: #fff;
}
.link-to {
  cursor: pointer !important;
  color: #873693 !important;
}
.link-to:hover {
  text-decoration: underline !important;
  color: #5e72e4 !important;
}
</style>